import './App.css';
import { Icon } from 'semantic-ui-react';
import Routes from './routes';
import AppMenu from './components/app-menu';
import { useNavigate, useLocation } from 'react-router-dom';
import _ from 'lodash';

function App() {
  const navigate = useNavigate();
  const location = useLocation();
  const pathname = location.pathname;
  const activeItem = _.isEqual(pathname, "/") ? "home" : pathname.substring(1);
  return (
    <div className="App">
      <header className="App-header">
        <img src={"https://avatars.githubusercontent.com/u/53671318?s=40&v=4"} className="App-logo" alt="logo" />
        Yungkei Personal Space
        <div className="App-header-extra">
          <a href='https://github.com/yungkei' className='App-github'>
            <Icon name='github' size='large' />
          </a>
        </div>
      </header>
      <div className='App-body'>
        <AppMenu
          activeItem={activeItem}
          onClick={(e, { name }) => {
            navigate(`${name}`, {});
          }} />
        <Routes />
      </div>
    </div>
  );
}

export default App;
